// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import BootstrapVue from "bootstrap-vue";
import "core-js/es/promise";
import "core-js/es/string";
import "core-js/es/array";
import Element from "element-ui";
import locale from "element-ui/lib/locale";
import enLocale from "element-ui/lib/locale/lang/en";
import viLocale from "element-ui/lib/locale/lang/vi";
// import Service
import mushroom from "viettoc-api";
import Vue from "vue";
//import google map
import * as VueGoogleMaps from "vue2-google-maps";
import App from "./App";
import filters from "./directive/filters";
// import directive
import ladda from "./directive/ladda";
import router from "./router";
import AuthService from "./service/AuthService";
import { store } from "./store/store";
import ElementUIMoney from "./service/ElementUIMoney";

Vue.use(BootstrapVue);
Vue.use(VueGoogleMaps, {
  load: {
    key: MyConfig.googleMapKey, // khai báo trong public/_config.js
    libraries: "places",
    region: "VI",
    language: "vi",
  },
});
Vue.filter("toCurrency", function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });
  return formatter.format(value);
});

// import library

window.jQuery = window.$ = require("jquery");
window.toastr = require("toastr");
toastr.options = {
  closeButton: true,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: true,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "2000",
  extendedTimeOut: "1000",
};
window.Ladda = require("ladda");

enLocale.el.datepicker.year = "";
viLocale.el.datepicker.year = "";

if (window.MyConfig.language == "vi") {
  locale.use(viLocale);
}
if (window.MyConfig.language == "en") {
  locale.use(enLocale);
}

Vue.use(Element, {
  size: "small",
  zIndex: 3000,
});

mushroom.$using(window.MyConfig.hostApi);

mushroom._on("beforeSend", function (arg) {
  arg.headers = arg.headers || {};
  arg.headers["X-Client"] = "AdminViettoc";
  arg.headers["X-Client-Platform"] = "Mushroom";
  arg.headers["X-Client-Version"] = "1.0";
});

Vue.directive("ladda", ladda);

Vue.filter("capitalize", filters.capitalize);

/* eslint-disable no-new */
window.vm = new Vue({
  el: "#app",
  router,
  ElementUIMoney,
  template: "<App/>",
  store,
  data: function () {
    return {};
  },
  components: {
    App,
  },
  methods: {},
  created: function () {},
});

// sesstion time out sau 30 phút 1800000
const timeoutInMS = 1800000; // 30 phút -> 30 * 60 * 1000
let timeoutId;

function handleInactive() {
  let urlTimeOut = "";
  AuthService.logout(false)
    .then((res) => {
      window.localStorage.clear();
      urlTimeOut = location.origin + "/auth/sesstionTimeOut";
      window.location.replace(urlTimeOut);
    })
    .catch();
}

function startTimer() {
  timeoutId = setTimeout(handleInactive, timeoutInMS);
}

function resetTimer() {
  clearTimeout(timeoutId);
  startTimer();
}

function setupTimers() {
  document.addEventListener("keypress", resetTimer, false);
  document.addEventListener("mousemove", resetTimer, false);
  document.addEventListener("mousedown", resetTimer, false);
  document.addEventListener("touchmove", resetTimer, false);

  startTimer();
}
setupTimers();
